"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagsProvider = exports.useFlagsStatus = exports.useFlag = exports.useUpdateFlagsContext = exports.WithFlag = void 0;
var with_flag_component_1 = require("./components/with-flag.component");
Object.defineProperty(exports, "WithFlag", { enumerable: true, get: function () { return with_flag_component_1.WithFlag; } });
var use_update_flags_context_hook_1 = require("./hooks/use-update-flags-context.hook");
Object.defineProperty(exports, "useUpdateFlagsContext", { enumerable: true, get: function () { return use_update_flags_context_hook_1.useUpdateFlagsContext; } });
var use_flag_hook_1 = require("./hooks/use-flag.hook");
Object.defineProperty(exports, "useFlag", { enumerable: true, get: function () { return use_flag_hook_1.useFlag; } });
var use_flags_status_hook_1 = require("./hooks/use-flags-status.hook");
Object.defineProperty(exports, "useFlagsStatus", { enumerable: true, get: function () { return use_flags_status_hook_1.useFlagsStatus; } });
var flags_provider_component_1 = require("./components/flags-provider.component");
Object.defineProperty(exports, "FlagsProvider", { enumerable: true, get: function () { return flags_provider_component_1.FlagsProvider; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map